import { render, staticRenderFns } from "./JobContent.vue?vue&type=template&id=39be1e28&scoped=true&"
import script from "./JobContent.vue?vue&type=script&lang=js&"
export * from "./JobContent.vue?vue&type=script&lang=js&"
import style0 from "./JobContent.vue?vue&type=style&index=0&id=39be1e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be1e28",
  null
  
)

export default component.exports